import { AppState } from 'Store'

const selectEntries = (state: AppState) => state.company.company.entries
const selectTotal = (state: AppState) => state.company.company.total_entries
const selectCurrentParams = (state: AppState) => state.company.requestParams
const selectFormState = (state: AppState) => state.company.formState

export const companySelectors = {
	selectEntries,
	selectTotal,
	selectCurrentParams,
	selectFormState,
}
